import type { ReactNode, Ref } from 'react';
import { forwardRef } from 'react';

import { TimeInput } from '@zen/DesignSystem';

import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';
import type { FormInstance } from '../types';

type TimeInputField = {
  name: string;
  onChange: () => void;
  value: string;
};

interface Props extends FormFieldProps {
  inline?: boolean;
  noMargin?: boolean;
  ref?: Ref<HTMLInputElement>;
}

const FormTimeInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { inline, ...otherProps } = props;

  return (
    <FormField {...otherProps}>
      {(field: TimeInputField, form: FormInstance<unknown>): ReactNode => {
        const handleChange = (timeInput: string): void => {
          form.setFieldValue(field.name, timeInput);
        };

        const variant: 'inline' | 'default' = inline ? 'inline' : 'default';

        return <TimeInput {...field} ref={ref} id={field.name} onChange={handleChange} variant={variant} />;
      }}
    </FormField>
  );
});

export default FormTimeInput;
